import {Navigate} from "react-router-dom";
import Layout from "../pages/Layout";
import useClientQuery from "../global/queries/useClientQuery";


const PrivateRoutes = () => {

    const {isSuccess, isLoading} = useClientQuery()

    if (isLoading) return null

    if (!isSuccess) return <Navigate to={"/login"}/>

    return <Layout />
}

export default PrivateRoutes;